import { STATEMENT_MAPPINGS } from "../../../config/medicalNecessityStatements";
import { ChecklistQuestion } from "../../../data-model/medicalNecessityReview";

export function injectStatements(
  questions: ChecklistQuestion[],
  orderId: string,
): ChecklistQuestion[] {
  const patientStatements = STATEMENT_MAPPINGS[orderId];

  if (!patientStatements) {
    return questions;
  }

  return questions.map((question) => {
    const statementForQuestion = patientStatements[question.id];

    // Recursively inject for nested children
    let updatedChildren = question.children;
    if (question.children) {
      updatedChildren = Object.keys(question.children).reduce(
        (acc, key) => {
          acc[key] = injectStatements(question.children![key], orderId);
          return acc;
        },
        {} as Record<string, ChecklistQuestion[]>,
      );
    }

    // Check if statementForQuestion is actually facts (not recommendation)
    const questionFacts =
      statementForQuestion &&
      ("supportive_facts" in statementForQuestion ||
        "contradictory_facts" in statementForQuestion)
        ? statementForQuestion
        : question.facts;

    return {
      ...question,
      facts: questionFacts,
      children: updatedChildren,
    };
  });
}

export function getRecommendation(orderId: string) {
  const patientStatements = STATEMENT_MAPPINGS[orderId];
  return patientStatements?.recommendation;
}
